<template>
  <li :class="[isFolder ? 'folder' : 'file']">
    <label
      :class="{'open': open || (this.model.need_open && this.model.need_open === true )  }"
      @click.self="toggle"
      >
      <div @click.self="toggle" class="row" style="width: 100%; display: flex; align-items: center;">
        <div class="col-md-2" @click.self="toggle">{{model.identifier}}</div>
        <div class="col-md-6" @click.self="toggle">{{model.name}}</div>
        <div class="col-md-1">
          <i v-if="model.type == 0" @click="addChild" class="add-category">{{$t('app.sub_criteria_categories.attributes.name')}}</i>
        </div>
        <div class="col-md-2">
          <i v-if="model.type !== 2" @click="addQuestion" class="add-question">{{$t('app.verification_questions.attributes.name')}}</i>
        </div>
        <div class="col-md-1 action-row">
          <v-popover v-if="model.type !== 2" :trigger="model.description && model.description !== null ? 'hover' : 'manual'">
              <i
                :class=" model.description && model.description !== null ? 'ti-info active' : `ti-info hidden-info`"
              ></i>
              <template slot="popover">
                <info-popup
                  :description="model.description"/>
              </template>
          </v-popover>
          <v-popover v-if="model.type === 2" :trigger="model.legal_description && model.legal_description !== null ? 'hover' : 'manual'">
              <i
                :class=" model.legal_description && model.legal_description !== null ? 'ti-info active' : `ti-info hidden-info`"
              ></i>
              <template slot="popover">
                <info-popup
                  :description="model.legal_description"/>
              </template>
          </v-popover>
          <i  v-if="model.type === 2 && ableToEdit(model.specializations)" @click="editItem('edit')" class="zmdi zmdi-edit action-button"></i>
          <i  v-else-if="model.type != 2" @click="editItem('edit')" class="zmdi zmdi-edit action-button"></i>
          <i  v-if="model.type === 2 && ableToEdit(model.specializations)" @click="deleteItem" class="zmdi zmdi-delete action-button"></i>
          <i  v-else-if="model.type != 2" @click="deleteItem" class="zmdi zmdi-delete action-button"></i>
        </div>
      </div>
    </label>
    <ul v-show="open || (this.model.need_open && this.model.need_open === true )" v-if="isFolder" :class="{'open': open}">
      <item
        v-for="(model, index) in model.children"
        :key="index"
        :selectedIndex="index"
        :parentIndex="selectedIndex"
        :bus="bus"
        :isSearch="isSearch"
        :model="model"/>
    </ul>
  </li>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GenericForm from '@/components/shared/forms/GenericForm';
import InfoPopUp from '@/components/modules/criteria_categories/InfoPopUp';

export default {
  name: 'item',
  components: {
    'info-popup': InfoPopUp,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    bus: {
      type: Object,
      required: false,
    },
    selectedIndex: {
      type: Number,
      required: false,
    },
    parentIndex: {
      type: Number,
      required: false,
    },
    isSearch: {
      type: Boolean,
      required: false,
    },
    searchType: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      open: false,
      newCriteriaCategory: {
        name: null,
        identifier: null,
        description: null
      },
      newVerificationQuestion: {
        identifier: null,
        name: null,
        legal_description: null,
        legal_reference: null
      },
      selectedSpecs: undefined,
      specs: undefined,
    };
  },
  created() {
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
    }),
    isFolder() {
      return this.model.children && this.model.children.length || this.model.type === 0 || this.model.type === 1;
    },
    userSpecs() {
      return this.loggedInUser.specializations.map(x => ({ value: x.id, text: x.name }));
    },
    criteriaCategoryAttributesForEdit() {
      if (this.model.type === 1) {
        return [
          {
            name: 'name',
            type: 'text',
          },
          {
            name: 'description',
            type: 'text-area',
            needValidation: false,
          },
        ];
      }
      return [
        {
          name: 'name',
          type: 'text',
        },
        {
          name: 'description',
          type: 'text-area',
          needValidation: false,
        },
      ];
    },
    criteriaCategoryAttributesForCreate() {
      return [
        {
          name: 'name',
          type: 'text',
        },
        {
          name: 'description',
          type: 'text-area',
          needValidation: false,
        },
      ];
    },
    verificationQuestionAttributes() {
      return [
        {
          name: 'specialization_id',
          type: 'checkboxList',
          action: 'selectUserSpec',
          list: this.userSpecs,
        },
        {
          name: 'name',
          type: 'text',
        },
        {
          name: 'legal_description',
          type: 'text-area',
          needValidation: false,
        },
        {
          name: 'legal_reference',
          type: 'text',
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      fetchCriteriaCategory: 'criteriaCategories/fetchCriteriaCategory',
      createNewCriteriaCategory: 'criteriaCategories/createCriteriaCategory',
      deleteCriteriaCategory: 'criteriaCategories/deleteCriteriaCategory',
      deleteVerificationQuestion: 'verificationQuestions/deleteVerificationQuestion',
      createNewVerificationQuestionForSubCategory:
        'verificationQuestions/createVerificationQuestionForSubCategory',
      updateCriteriaCategoryParams: 'criteriaCategories/updateCriteriaCategory',
      updateVerificationQuestionParams:
        'verificationQuestions/updateVerificationQuestion',
      fetchVerificationQuestion:
        'verificationQuestions/fetchVerificationQuestionWithCategoryId',
    }),
    ableToEdit(specializations) {
      const userSpecIds = this.loggedInUser.specializations.map(spec => spec.id);
      return userSpecIds.some(id => specializations.includes(id));
    },
    selectSpec(payload) {
      this.selectedSpecs = payload;
    },
    toggle() {
      if (this.isFolder) {
        if (this.model.need_open) {
          this.model.need_open = false;
          this.open = false;
        } else {
          this.open = !this.open;
        }
      }
      if (this.model.type === 0 && !this.isSearch) {
        this.bus.$emit('getChild', this.model.id, this.selectedIndex);
      }
    },
    changeType() {
      if (!this.isFolder) {
        this.set(this.model, 'children', []);
        this.addChild();
        this.open = true;
      }
    },
    addChild() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t('app.sub_criteria_categories.set_sub_criteria_category'),
          fields: this.criteriaCategoryAttributesForCreate,
          model: this.newCriteriaCategory,
          submitTitle: this.$t('app.criteria_categories.buttons.save'),
          cancelTitle: this.$t('app.criteria_categories.buttons.cancel'),
          modelName: 'sub_criteria_categories',
        },
        on: {
          submit: this.createCriteriaCategory,
          modalCanceled: this.resetNewCriteriaCategory,
        },
      });
    },
    addQuestion() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t(
            'app.verification_questions.set_verificatoin_question',
          ),
          fields: this.verificationQuestionAttributes,
          model: this.newVerificationQuestion,
          submitTitle: this.$t('app.verification_questions.buttons.save'),
          cancelTitle: this.$t('app.verification_questions.buttons.cancel'),
          modelName: 'verification_questions',
        },
        on: {
          submit: this.createVerificationQuestionForSubCategory,
          modalCanceled: this.resetNewVerificationQuestion,
          selectSpec: this.selectSpec,
        },
      });
    },
    createCriteriaCategory(newCriteriaCategory) {
      newCriteriaCategory.parent_id = this.model.id;
      this.createNewCriteriaCategory(newCriteriaCategory)
        .then((response) => {
          this.model.children.push({
            id: response.id,
            name: response.name,
            identifier: response.identifier,
            description: response.description,
            children: [],
            type: 1,
          });
          this.$eventBus.showNotification({
            notificationText: this.$t('app.criteria_categories.success.sub_create'),
            notificationType: 'success',
          });
          this.resetNewCriteriaCategory();
          this.$eventBus.hideModal();
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    createVerificationQuestionForSubCategory(newVerificationQuestion) {
      newVerificationQuestion.specializations = this.selectedSpecs;
      if (newVerificationQuestion && newVerificationQuestion.locales && newVerificationQuestion.locales.hu.name.length > 300) {
        const lengthError = [this.$t('app.verification_questions.length_error')];
        this.$eventBus.stopLoading();
        this.$eventBus.getError(lengthError);
      } else {
        this.createNewVerificationQuestionForSubCategory({ params: newVerificationQuestion, categoryId: this.model.id })
          .then((response) => {
            this.model.children.unshift({
              id: response.id,
              main_idx: this.parentIndex !== undefined ? this.parentIndex : this.selectedIndex,
              category_id: this.model.id,
              name: response.name,
              identifier: response.identifier,
              legal_description: response.legal_description,
              legal_reference: response.legal_reference,
              children: [],
              type: 2,
              for_main_category: this.model.type === 0,
              specializations: this.selectedSpecs,
            });
            this.selectedSpecs = undefined;
            this.resetNewVerificationQuestion();
            this.$eventBus.showNotification({
              notificationText: this.$t('app.verification_questions.success.create'),
              notificationType: 'success',
            });
            newVerificationQuestion.specializations = [];
            this.$eventBus.hideModal();
          })
          .catch((error) => {
            this.$eventBus.stopLoading();
            const mappedErrors = error.map(x => ` ${x}`);
            this.$eventBus.getError(mappedErrors);
          });
      }
    },
    deleteItem() {
      this.$swal
        .fire({
          html: this.$t('app.notifications.general_confirm.title'),
          type: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: this.$t('app.notifications.general_confirm.ok'),
          cancelButtonText: this.$t('app.notifications.general_confirm.cancel'),
        })
        .then((result) => {
          if (result.value) {
            if (this.model.type !== 2) {
              this.deleteCriteriaCategory(this.model.id)
                .then((response) => {
                  this.bus.$emit('deleteCategory', this.parentIndex, this.selectedIndex);
                  this.$eventBus.showNotification({
                    notificationText: this.$t('app.criteria_categories.success.delete'),
                    notificationType: 'success',
                  });
                })
                .catch((error) => {
                  this.$swal
                    .fire({
                      html: this.$t('app.criteria_categories.errors.deletion_error'),
                      type: 'error',
                      showCloseButton: true,
                      showCancelButton: false,
                      showConfirmButton: false,
                      focusConfirm: false,
                    });
                });
            } else {
              this.deleteVerificationQuestion({ id: this.model.id, categoryId: this.model.category_id })
                .then((response) => {
                  this.$eventBus.showNotification({
                    notificationText: this.$t('app.verification_questions.success.delete'),
                    notificationType: 'success',
                  });
                  this.$eventBus.hideModal();
                  if (this.model.for_main_category === true) {
                    this.bus.$emit('deleteQuestion', this.parentIndex, this.selectedIndex);
                  } else {
                    this.bus.$emit('deleteQuestionForSub', this.model.main_idx, this.parentIndex, this.selectedIndex);
                  }
                })
                .catch((error) => {
                  const errorMessage = error && error.length > 0 ? error[0] : this.$t('app.statements.errors.deletion_error')
                  this.$swal
                    .fire({
                      html: errorMessage,
                      type: 'error',
                      showCloseButton: true,
                      showCancelButton: false,
                      showConfirmButton: false,
                      focusConfirm: false,
                    });
                  this.$eventBus.hideModal();
                });
            }
          }
        });
    },
    editItem() {
      if (this.model.type !== 2) {
        this.fetchCriteriaCategory(this.model.id)
          .then((response) => {
            this.criteriaCategory = response;
            this.$eventBus.showModal({
              bind: {
                is: GenericForm,
                title: this.model.type === 1 ? this.$t('app.criteria_categories.edit_sub_criteria_category') : this.$t('app.criteria_categories.edit_criteria_category'),
                fields: this.criteriaCategoryAttributesForEdit,
                model: this.criteriaCategory,
                submitTitle: this.$t('app.partners.buttons.save'),
                cancelTitle: this.$t('app.partners.buttons.cancel'),
                modelName: 'criteria_categories',
              },
              on: {
                submit: this.updateCriteriaCategory,
              },
            });
          })
          .catch((error) => {
            this.$swal
              .fire({
                html: error[0],
                type: 'error',
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              });
          });
      } else {
        this.fetchVerificationQuestion({ id: this.model.id, categoryId: this.model.category_id })
          .then((response) => {
            if (response.specializations !== undefined) {
              this.selectedSpecs = response.specializations.map(x => x.name);
            }
            this.$eventBus.showModal({
              bind: {
                is: GenericForm,
                title: this.$t(
                  'app.verification_questions.edit_verificatoin_question',
                ),
                fields: this.verificationQuestionAttributes,
                model: response,
                submitTitle: this.$t('app.verification_questions.buttons.save'),
                cancelTitle: this.$t(
                  'app.verification_questions.buttons.cancel',
                ),
                modelName: 'verification_questions',
              },
              on: {
                selectSpec: this.selectSpec,
                submit: this.updateVerificationQuestion,
              },
            });
          })
          .catch((error) => {
            this.$swal
              .fire({
                html: error[0],
                type: 'error',
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              });
          });
      }
    },
    updateCriteriaCategory(criteriaCategory) {
      this.updateCriteriaCategoryParams(criteriaCategory)
        .then((response) => {
          const category = {
            name: response.name,
            description: response.description,
          };
          this.bus.$emit('updateCategory', this.parentIndex, this.selectedIndex, category);
          this.$eventBus.hideModal();
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    updateVerificationQuestion(verificationQuestion) {
      // eslint-disable-next-line no-param-reassign
      verificationQuestion.specializations = this.selectedSpecs;
      this.updateVerificationQuestionParams({ id: this.model.category_id, params: verificationQuestion })
        .then((response) => {
          const question = {
            name: response.name,
            legal_description: response.legal_description,
            legal_reference: response.legal_reference,
          };
          if (this.model.for_main_category === true) {
            this.bus.$emit('updateQuestion', this.parentIndex, this.selectedIndex, question);
          } else {
            this.bus.$emit('updateQuestionForSub', this.model.main_idx, this.parentIndex, this.selectedIndex, question);
          }
          this.$eventBus.hideModal();
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    resetNewCriteriaCategory() {
      Object.assign(
        this.$data.newCriteriaCategory,
        this.$options.data().newCriteriaCategory,
      );
    },
    resetNewVerificationQuestion() {
      Object.assign(
        this.$data.newVerificationQuestion,
        this.$options.data().newVerificationQuestion,
      );
    },
  },
  watch: {
    isSearch(newValue, oldValue) {
      // this.open = newValue
    },
  },
};
</script>

<style lang="scss" scoped>
  /deep/ .v-popover {
    span:focus {
      outline: none;
    }
  }
  .ti-info.hidden-info{
    visibility: hidden;
  }

  label {
    display: flex !important;
    justify-content: space-between;
  }

  .icons-row {
    display: flex;
    align-items: center;
  }

  .model-id, .model-name {
    float: left !important;
    margin-right: 50px;
    line-height: 50px;

  }

  .model-name {
    width: 100%;
  }
  .model-id {
    min-width: 120px;
  }
  .action-button {
    cursor: pointer;
    margin-left: 30px;
    margin-top: 3px;
  }

  .add-question,
  .add-category {
    cursor: pointer;
    // margin-left: 40px;
    font-size: 14px;
    font-weight: 500;
  }
  // .add-question {
  //   margin-left: 80px;
  //   margin-right: 80px;
  // }

  .add-question:before,
  .add-category:before {
    font: normal normal normal 14px/1 FontAwesome;
    left: 18px;
    content: "\f067";
    margin-right: 5px;
  }

  .action-row {
    display: flex;
    justify-content: flex-end;
    padding-right: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/criteria_categories/CategoryItem.vue